import {inject} from '@angular/core';
import {CanActivateFn, CanDeactivateFn, Router} from '@angular/router';
import {ApyreAuthService} from '@portal-firebase';
import {LoginComponent} from '../login/login.component';
import {map} from 'rxjs';

export const canActivateLogin: CanActivateFn = (route, state) => {
  const auth = inject(ApyreAuthService);
  const router = inject(Router);
  return auth.settledUser$.pipe(
    map((user) => (user ? router.createUrlTree(['/app']) : true)),
  );
};

export const canDeactivateLogin: CanDeactivateFn<LoginComponent> = (comp, route, state) => {
  const auth = inject(ApyreAuthService);
  return auth.settledUser$.pipe(map((user) => !!user));
};
